'use strict';

namespace Core {

    class FlightListing {

        // Attr
        flight: any;
        appliedBags: number;
        nonInfantPassengers: number;
        isFirst: boolean;
        recentlyViewed: boolean;
        signedIn: boolean;
        depositMessage: string;
        buttonType: string;
        flightButtonText: string;
        basePrice: number;
        isFlightsPage: boolean = false;
        showPrice: boolean;
        showInfo: boolean;
        showChangeFlight: boolean;
        trackingPage: string;
        showButton: boolean;
        showTax: boolean;
        showDeposit: boolean;
        showBaggage: boolean;
        flightAction: (f) => void;
        busy: boolean;
        trip: any = localStorage.getItem('trip');
        qtys: any = sessionStorage.getItem('priceQtys');
        hotel: any = sessionStorage.getItem('hotelData');
        flightsSkywards: any = sessionStorage.getItem('flightsSkywards');
        skywardsPoints: number = 0;
        flightMiles: number = 0;
        sentPayload: boolean = false;
        flightInfo: any;
        skywardsFlightMiles: any = sessionStorage.getItem('SkywardsMilesFlights');
        tripDetailInfo: any;

        constructor(
            private tripService: any,
            private $routeParams: ng.route.IRouteParamsService,
            private basketStore: any,
            private broker: any,
            private resourceService: any,
            private $scope: any,
            private occupancyService: any,
            private basketService: any,
            private flightSearch: any,
            private analytics: any,
            private flightDetail: any,
            private brandedFareTypesService: ekh.BrandedFareTypesService,
            private guidService: Core.GuidService,
            private hotelSearch: any,
        ) {
            //update properties after flight provided ( selected flight )
            if (!this.flight) {
                this.buttonType = this.buttonType ? this.buttonType : 'select';
                const flightWatch = this.$scope.$watch('fl.flight', (value) => {
                    if (value) {
                        this.update();
                        flightWatch();
                    }
                });
            } else {
                this.update();
            }
        }

        update() {
            if (!this.tripDetailInfo && TRPCONFIG.Domain.EnableFlightDetailsWithBrandedFare && this.flight.$$hashKey) {
                this.tripService.getTrip(this.$routeParams.tripId).then(tr => {
                    this.tripDetailInfo = tr;
                    if (this.tripDetailInfo && this.$routeParams.tripId && this.flight.FlightId) {
                        const searchId = this.tripDetailInfo.FlightsRequest.AvailabilitySearchId;
                        return this.flightDetail.getFlightDetails(this.$routeParams.tripId, {
                            AvailabilitySearchId: searchId,
                            FlightId: this.flight.FlightId,
                            IncludeSeatPlan: true,
                            MultiSector: false,
                            IncludeBrandedFares: true
                        })
                            .then((details) => {
                                this.flight.Legs = details.Itinerary.Legs;
                             });
                    }
                });
            }
            this.recentlyViewed = this.isFirst && this.flight.RecentlyViewedIndex === 1;
            this.buttonType = this.buttonType ? this.buttonType : 'select';
            this.isFlightsPage = window.location.pathname.includes('flights')
            || window.location.pathname.includes('quote');
            this.flight && this.flight.Legs && this.flight.Legs[0] ?
            this.flight.Legs[0].isFlightsPage = this.isFlightsPage : '';
            this.flight && this.flight.Legs && this.flight.Legs[1] ?
            this.flight.Legs[1].isFlightsPage = this.isFlightsPage : '';
            this.showButton = this.buttonType === 'none' ? false : true;
            this.showTax = this.showPrice && this.getTotalPrice() > 0 || false;
            this.showDeposit = this.showInfo && this.flight && this.flight.DepositAmount > 0;
            this.showBaggage = TRPCONFIG.Domain.DisplayBaggageFeesLink
                && this.flight
                && this.flight.Legs
                && this.flight.Legs.some(function (leg) { return leg.IsMixedCarrier === true; });
        }

        init() {
            this.depositMessage = this.signedIn
                ? this.resourceService.get('FLIGHTLISTINGDEPOSITCAPTIONSIGNEDIN')
                : this.resourceService.get('FLIGHTLISTINGDEPOSITCAPTION');

            this.flightButtonText = this.buttonType && this.buttonType.toLowerCase() === 'keep'
                ? this.resourceService.get('KEEPTHISFLIGHT')
                : this.resourceService.get('SELECTFLIGHTTEXT');
        }

        showDetails() {
            const passengers = this.occupancyService.getTotalPeopleCounts();
            this.broker.publish('showModalFlightDetails', { flight: this.flight, passengers });
        }

        changeFlight() {
            this.analytics.track('mixpanel', 'ChangeFlightClick');
            this.flightSearch.resetPageIndex();
            this.basketService.changeJourneyUrl(10);
        }

        stops(n) {
            return n === '' ? undefined : new Array(parseInt(n, 10));
        }

        selectFlightAction() {
            this.flightAction({ f: this.flight });
        }

        public async calculateSkywardsPoints(flight) {
            let trip = JSON.parse(this.trip);
            let qtys = JSON.parse(this.qtys);
            this.flightInfo = flight;

            if (!TRPCONFIG.Domain.FlightMiles) {
                TRPCONFIG.Domain.FlightMiles = [];
            }

            if (qtys === null || qtys === undefined) {
                const defaultFlightData = JSON.parse(sessionStorage.getItem('DefaultFlight') || '');
                if (defaultFlightData && defaultFlightData.Details.Itinerary.AdultFareQuantity) {
                    qtys = {};
                    qtys.AdultTaxQuantity = defaultFlightData.Details.Itinerary.AdultFareQuantity;
                    qtys.ChildTaxQuantity = defaultFlightData.Details.Itinerary.ChildTaxQuantity;
                    qtys.InfantTaxQuantity = defaultFlightData.Details.Itinerary.InfantTaxQuantity;
                }
            }

            if (flight && flight.Legs && flight.Legs.length) {
                let legs = flight.Legs;
                let hotel = JSON.parse(this.hotel);

                if (qtys && qtys.AdultTaxQuantity) {
                    let adultQty = qtys.AdultTaxQuantity;
                    let childQty = qtys.ChildTaxQuantity;
                    let infantQty = qtys.InfantTaxQuantity;

                    let adultTax = flight.AdultTax.Amount * adultQty;
                    let childTax = flight.ChildTax.Amount * childQty;
                    let infantTax = flight.InfantTax.Amount * infantQty;

                    let totalFlightTax = adultTax + childTax + infantTax;
                    let packagePrice = flight.totalHolidayPrice - totalFlightTax;
                    let flightId = flight.FlightId;
                    if (packagePrice && !Number.isNaN(packagePrice)) {
                        if (this.sentPayload === false) {
                            this.sentPayload = true;
                            await this.brandedFareTypesService.payloadEntry(flightId, trip, legs, hotel, packagePrice)
                                .then(result => {
                                    if (result[0].Miles && TRPCONFIG.Domain.FlightMiles) {
                                        TRPCONFIG.Domain.FlightMiles.push(result[0].Miles);
                                        sessionStorage.setItem('FlightMiles',
                                            JSON.stringify(TRPCONFIG.Domain.FlightMiles));
                                        this.skywardsPoints = result[0].Miles;
                                        this.getFlightMiles(flight, legs);
                                    }
                            });
                        }
                    }
                }
            }
        }

        getPassengerCount() {
            const priceQtys = sessionStorage.getItem('priceQtys');
            const defaultFlight = sessionStorage.getItem('DefaultFlight');
            const defaultFlightDetails = defaultFlight ? JSON.parse(defaultFlight) : null;
            const passengers = priceQtys ? JSON.parse(priceQtys) : defaultFlightDetails ?
            defaultFlightDetails.Details.Itinerary : null;
            return {
                infantCount: passengers.InfantFareQuantity ? passengers.InfantFareQuantity : 0,
                childCount: passengers.ChildFareQuantity ? passengers.ChildFareQuantity : 0,
                adultCount: passengers.AdultFareQuantity ? passengers.AdultFareQuantity : 0
            };
        }

        getBasePrice() {
            const p = this.getPassengerCount();
            const storeSelectedFlight = sessionStorage.getItem('storeSelectedFlight');
            const defaultFlight = sessionStorage.getItem('DefaultFlight');
            const defaultFlightDetails = defaultFlight ? JSON.parse(defaultFlight) : null;
            const selectedFlightData = storeSelectedFlight ? JSON.parse(storeSelectedFlight) : defaultFlightDetails ?
            defaultFlightDetails.Details.Itinerary : null;
            return (
                (p.adultCount * ((selectedFlightData.LeadAdultPrice ?
                selectedFlightData.LeadAdultPrice : selectedFlightData.AdultFare.Amount)
                + (selectedFlightData.LeadAdultTax ?
                selectedFlightData.LeadAdultTax : selectedFlightData.AdultTax.Amount)))
                + (p.childCount * (selectedFlightData.ChildFare.Amount + selectedFlightData.ChildTax.Amount))
                + (p.infantCount * (selectedFlightData.InfantFare.Amount + selectedFlightData.InfantTax.Amount))
            );
        }

        getTotalPrice() {
            const p = this.getPassengerCount();
                return (
                    (p.adultCount * (this.flight.LeadAdultPrice + this.flight.LeadAdultTax))
                    + (p.childCount * (this.flight.ChildFare.Amount + this.flight.ChildTax.Amount))
                    + (p.infantCount * (this.flight.InfantFare.Amount + this.flight.InfantTax.Amount))
                );
        }

        isHFareFlightType(): boolean {
            return this.flightDetail.isHFlightType(this.flight);
        }
        getCabinCode(cabinType) {
            switch (cabinType) {
                case 'Economy':
                    return 'Y';
                case 'Premium Economy':
                    return 'W';
                case 'Business':
                    return 'J';
                case 'First':
                    return 'F';
                default:
                    return '';
            }
        }
        getDepartureCode(legs) {
            for (let i = 0; i < legs.length; i++) {
                if (legs[i].LegType === 'outbound') {
                    return legs[i].DepartureAirport.Code;
                }
            }
        }
        getDestinationCode(legs) {
            for (let i = 0; i < legs.length; i++) {
                if (legs[i].LegType === 'outbound') {
                    return legs[i].ArrivalAirport.Code;
                }
            }
        }
        public getFareBrandTitle(supplierfareclass) {
            switch (supplierfareclass) {
                case 'F':
                    return 'First Flex Plus';
                case 'A':
                    return 'First Flex';
                case 'Z':
                    return 'First Others';
                case 'J':
                    return 'Business Flex Plus';
                case 'C':
                    return 'Business Flex Plus';
                case 'I':
                    return 'Business Flex';
                case 'O':
                    return 'Business Saver';
                case 'H':
                    return 'Business Special';
                case 'D':
                    return 'Business Others';
                case 'P':
                    return 'Business Others';
                case 'W':
                    return 'Premium Economy Flex Plus';
                case 'E':
                    return 'Premium Economy Flex Plus';
                case 'N':
                    return 'Premium Economy Others';
                case 'Y':
                    return 'Economy Flex Plus';
                case 'R':
                    return 'Economy Flex Plus';
                case 'M':
                    return 'Economy Flex';
                case 'B':
                    return 'Economy Flex';
                case 'U':
                    return 'Economy Flex';
                case 'K':
                    return 'Economy Flex';
                case 'Q':
                    return 'Economy Saver';
                case 'L':
                    return 'Economy Saver';
                case 'T':
                    return 'Economy Saver';
                case 'X':
                    return 'Economy Special';
                case 'V':
                    return 'Economy Saver';
                case 'G':
                    return 'Economy Others';
                case 'S':
                    return 'Economy Others';
                default:
                    return '';
            }

        }

        public async  getFlightMiles(flight, legs) {
            let origin = this.getDepartureCode(legs);
            let destination = this.getDestinationCode(legs);
            let spplierClassFirstLeg = flight.Legs[0].Segments[0].SupplierFareClass;
            let spplierClassSecondLeg = flight.Legs[1].Segments[0].SupplierFareClass;
            let getBrandTitleFirstLeg = this.getFareBrandTitle(spplierClassFirstLeg);
            let getBrandTitleSecondLeg = this.getFareBrandTitle(spplierClassSecondLeg);

            let legsAreNotEmpty = getBrandTitleFirstLeg !=='' && getBrandTitleSecondLeg !=='';
            let firstLegEqualsSecondLeg = legsAreNotEmpty && getBrandTitleFirstLeg === getBrandTitleSecondLeg;

            this.brandedFareTypesService.getFareInfo(legsAreNotEmpty, firstLegEqualsSecondLeg, this.skywardsFlightMiles,
            flight, this.hotelSearch, origin, destination, getBrandTitleFirstLeg, getBrandTitleSecondLeg);
        }
    }
    angular
        .module('core')
        .directive('flightListing', (): ng.IDirective => {

            return {
                scope: {},
                restrict: 'E',
                replace: true,
                transclude: true,
                bindToController: {
                    flight: '=',
                    appliedBags: '=',
                    nonInfantPassengers: '=',
                    isFirst: '=',
                    signedIn: '=',
                    buttonType: '@',
                    flightAction: '&',
                    showPrice: '=',
                    basePrice: '@',
                    showInfo: '=',
                    showChangeFlight: '=',
                    trackingPage: '=',
                    busy: '='
                },
                controller: FlightListing,
                controllerAs: 'fl',
                templateUrl: 'partials/home/directivetemplate?type=FlightListing',

                link: function (scope: ng.IScope, el: ng.IAugmentedJQuery, attr, controller: FlightListing) {
                    controller.init();
                }

            };

        });

}
